var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChinaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_1130)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_44_1130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-13.3828 3.36914H95.5229V77.3691H-13.3828V3.36914Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7651 55.1259L32.7059 51.7504L28.9059 52.7025L31.4322 49.6516L29.3729 46.2762L33.0031 47.7691L35.5082 44.7183L35.2322 48.6996L38.8624 50.1925L35.0623 51.1446L34.7651 55.1259ZM48.3094 21.1118L46.1652 24.444L48.6278 27.5382L44.8702 26.4996L42.7261 29.8534L42.5138 25.8721L38.7562 24.8335L42.4076 23.4054L42.1953 19.4241L44.6579 22.5183L48.3094 21.1118ZM36.7607 8.86505L36.3361 12.8247L39.9026 14.4691L36.0813 15.2914L35.6568 19.251L33.7037 15.789L29.9037 16.6113L32.5148 13.6469L30.5618 10.2066L34.1283 11.8294L36.7607 8.86505ZM48.7764 38.3785L45.6132 40.737L46.8445 44.5235L43.6814 42.1867L40.5182 44.5668L41.7071 40.7586L38.5439 38.4434L42.4501 38.4218L43.6389 34.6136L44.8702 38.4001L48.7764 38.3785ZM11.0309 13.3873L14.7036 24.9633H26.6344L16.9963 32.082L20.669 43.658L11.0309 36.5177L1.37165 43.658L5.06552 32.082L-4.59375 24.9633H7.35827L11.0309 13.3873Z",
    fill: "#FFDA44"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -12.8828,
    y: 3.86914,
    width: 107.906,
    height: 73,
    stroke: "#C4C4C4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    stroke: "white",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_1130"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 74,
    height: 74,
    rx: 37,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_44_1130"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13.3828,
    y: 3.36914,
    width: 108.906,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinaFlag);
export default __webpack_public_path__ + "static/media/china-flag.91ea98f5e40d562061cd8739928f6a52.svg";
export { ForwardRef as ReactComponent };